var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeDoubleT(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 20,
    height: 20,
    transform: "translate(4.291 4.29)",
    fill: "#ed8b00",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013",
    transform: "translate(-4.291 -4.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_635",
    "data-name": "Mask Group 635",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "text-size",
    d: "M19.5,1H8.5a.5.5,0,0,0-.5.5V4a.5.5,0,0,0,.5.5H9A.5.5,0,0,0,9.5,4V3H13V13.5H11.5a.5.5,0,0,0-.5.5v.5a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V14a.5.5,0,0,0-.5-.5H15V3h3.5V4a.5.5,0,0,0,.5.5h.5A.5.5,0,0,0,20,4V1.5A.5.5,0,0,0,19.5,1ZM9.5,7H.5a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5H1a.5.5,0,0,0,.5-.5v-1H4v5H3a.5.5,0,0,0-.5.5v.5A.5.5,0,0,0,3,15H7a.5.5,0,0,0,.5-.5V14a.5.5,0,0,0-.5-.5H6v-5H8.5v1A.5.5,0,0,0,9,10h.5a.5.5,0,0,0,.5-.5v-2A.5.5,0,0,0,9.5,7Z",
    transform: "translate(4.291 6.29)",
    fill: "#ed8b00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDoubleT);
export default __webpack_public_path__ + "static/media/orange-doubleT.1a7463dc75ef175b19ff5b9b10df985f.svg";
export { ForwardRef as ReactComponent };